const INITIAL_STATE = {
	aula: [],
	conteudo: [],
	aulas: [],
	aula_conteudo: [],
	comments: [],
	uploads: [],
	modalShow: false,
	question: [],
	loadquestion: true,
	sendtext: 'Enviar',
	loadmedia: false
}

const contentReducer = (state = INITIAL_STATE, action) => {
	switch(action.type){
		case 'AULA_FETCH':
			return {
				...state, 
				aula: action.payload
			}
		case 'AULAS_FETCH':
			return {
				...state, 
				aulas: action.payload
			}
		case 'CONTEUDO_FETCH':
			return {
				...state, 
				conteudo: action.payload
			}
		case 'AULA_CONTEUDO_FETCH':
			return {
				...state, 
				aula_conteudo: action.payload
			}
		case 'COMMENTS_FETCH':
			return {
				...state, 
				comments: action.payload
			}
		case 'UPLOADS_FETCH':
			return {
				...state, 
				uploads: action.payload
			}
		case 'OPEN_MODAL':
			return {
				...state,
				modalShow: action.payload
			}
		case 'LOAD_QUESTION':
			return {
				...state,
				loadquestion: action.payload
			}
		case 'LOADING_MEDIA':
			return {
				...state,
				loadmedia: action.payload
			}
		case 'QUESTION_FETCH':
			return {
				...state,
				question: action.payload
			}
		case 'SEND_TEXT_CHANGE':
			return {
				...state,
				sendtext: action.payload
			}
		default:
			return state
	}
}

export default contentReducer